import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

import addKey from '../../../utils/addKey.jsx';

function DaySlider({
  days, isBlock = false, selectedDay, setDayChanged, setSelectedDay,
}) {
  const hasSideImages = document.querySelector('.js-side-images');
  const siteType = window.location.host.includes('grandprix') ? 'formula-one' : 'moto-gp';

  const [instructionsSeen, setInstructionsSeen] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [slidesPerView, setSlidesPerView] = useState(0);
  const [width, setWidth] = useState(window.outerWidth);

  const closeInstructions = () => {
    setShowInstructions(false);
    setInstructionsSeen(true);
  };

  useEffect(() => {
    const updateWindowDimensions = () => setWidth(window.outerWidth);

    window.addEventListener('resize', updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (width > 900) {
      setSlidesPerView(hasSideImages ? 3.3 : 6.3);
    } else if (width > 600) {
      setSlidesPerView(3.3);
    } else {
      setSlidesPerView(2.3);
    }
  }, [width]);

  useEffect(() => {
    if (!instructionsSeen) {
      setShowInstructions(slidesPerView !== 0 && days.length > slidesPerView);
    }
  }, [days.length, slidesPerView]);

  useEffect(() => {
    if (showInstructions && !instructionsSeen) setTimeout(() => closeInstructions(), 10000);
  }, [showInstructions, instructionsSeen]);

  return (
    <section className="o-section o-section--no-bottom-padding">
      <div className="o-container">
        <div className="o-grid">
          <div className="o-col">
            <Swiper
              breakpoints={{
                900: {
                  preventInteractionOnTransition: true,
                },
              }}
              className={`
                c-ticket-selector
                c-ticket-selector__passes
                swiper-container
                swiper-pointer-events
                ${isBlock ? 'c-ticket-selector--no-margin-top' : ''}`}
              direction="horizontal"
              preventClicks={false}
              preventClicksPropagation={false}
              resistanceRatio={0}
              slidesPerView={slidesPerView}
              threshold={10}
              modules={[Navigation]}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enabled: true,
              }}
              watchSlidesProgress
            >
              {showInstructions && (
                <div
                  className="c-ticket-selector__instructions"
                  onClick={closeInstructions}
                  onKeyDown={closeInstructions}
                  role="contentinfo"
                >
                  <span>Swipe to see all your options</span>

                  <img
                    src={siteType === 'formula-one' ? '/images/icon_drag.svg' : '/images/icon_drag-motogp.svg'}
                    alt="swipe left or right"
                  />
                </div>
              )}
              <div className="swiper-wrapper">
                {days.map((day, i) => {
                  const soldOut = day.soldOut || false;
                  const titleSplit = day.title.split('-');
                  const title = titleSplit.length > 1
                    ? [
                      addKey(titleSplit[0], 0),
                      addKey('-', 1),
                      addKey(<br />, 2),
                      addKey(titleSplit[1], 3),
                    ]
                    : titleSplit;

                  const handleClick = () => {
                    setDayChanged(true);
                    setSelectedDay(day.value);
                  };

                  return (
                    <SwiperSlide className="c-ticket-selector__pass swiper-slide" key={day.value} virtualIndex={i}>
                      <div>
                        <input
                          checked={day.value === selectedDay}
                          id={day.value}
                          name="day"
                          onChange={handleClick}
                          required
                          type="radio"
                          value={day.value}
                        />

                        <label
                          className="c-ticket-selector__pass-label"
                          htmlFor={day.value}
                        >
                          <span className="c-ticket-selector__pass-meta">{title}</span>
                          <span className="c-ticket-selector__pass-title-wrapper">
                            {soldOut
                              ? <span className={`c-ticket-selector__pass-title${days.length <= 4 ? '--day' : ''}`}>Unavailable</span>
                              : <span className="c-ticket-selector__pass-title">{day.description}</span>}
                          </span>
                        </label>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </div>

              <div className="swiper-button-next u-none" />
              <div className="swiper-button-prev u-none" />
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

DaySlider.propTypes = {
  days: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired).isRequired,
  isBlock: PropTypes.bool,
  selectedDay: PropTypes.string.isRequired,
  setDayChanged: PropTypes.func.isRequired,
  setSelectedDay: PropTypes.func.isRequired,
};

export default DaySlider;
